import { Avatar } from "antd";
import { ReactNode } from "react";
import Asider from "~@/components/ASider";
import DefaultAvatar from "~@/assets/images/default_avatar.png";
const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="wrapper flex-1">
      <Asider />
      <main className="h-full w-full max-h-screen overflow-auto">
        <header className="sticky top-0 z-10 h-[53px] bg-white w-full flex items-center px-[20px]">
          <div className="ml-auto ">
            <Avatar src={DefaultAvatar} />
          </div>
        </header>
        <section className="p-[24px]">{children}</section>
      </main>
    </div>
  );
};

export default Layout;
